import { Share } from '@ori-ui/icons';
import { styled, Button } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { translationKeys } from '~/models';

interface ShareButtonProps {
  onClick: React.MouseEventHandler<HTMLButtonElement> | undefined;
}

const Root = styled(Button)(({ theme }) => ({
  width: 'calc(100% - 10px)',
  margin: theme.spacing(1),
}));

export const ShareButton: FC<ShareButtonProps> = ({ onClick }) => {
  const { getTestId } = useTestId();

  return (
    <Root
      data-testid={getTestId('minibag-share-panel-button')}
      variant="contained"
      color="secondary"
      onClick={onClick}
    >
      <Share />
      <FormattedMessage id={translationKeys.shareYourBasket} />
    </Root>
  );
};
